import { RugbyUnionIncidentId } from '@collector/sportsapi-client-legacy'

export const incidentsRequireConfirmation = [
  RugbyUnionIncidentId.Try,
  RugbyUnionIncidentId.PenaltyTry,
  RugbyUnionIncidentId.ConversionGoal,
  RugbyUnionIncidentId.ConversionMissed,
  RugbyUnionIncidentId.PenaltyKickGoal,
  RugbyUnionIncidentId.PenaltyKickMissed,
  RugbyUnionIncidentId.DropGoal,
]
